import type {
  ThemeBottomImageRatio,
  ThemeBottomSectionImageItem,
  ThemeBottomSectionState,
  ThemeBottomSectionVideo,
} from "@/models/ITrackingPageOptions"

const normalizeImageItems = (items: ThemeBottomSectionImageItem[]): ThemeBottomSectionImageItem[] =>
  items.map((item) => ({
    ...item,
    enabled: item.enabled !== false,
    destinationUrl: item.destinationUrl ?? "",
    openInNewWindow: item.openInNewWindow !== false,
  }))

const normalizeVideo = (raw: ThemeBottomSectionVideo | undefined): ThemeBottomSectionVideo | undefined => {
  if (!raw) {
    return undefined
  }

  return {
    ...raw,
    enabled: raw.enabled !== false,
  }
}

export const createDefaultThemeBottomSection = (): ThemeBottomSectionState => ({
  images: [],
  video: undefined,
  imageRatio: "SQUARE",
})

const normalizeImageRatio = (raw: unknown): ThemeBottomImageRatio => {
  if (raw === "AUTO" || raw === "SQUARE" || raw === "PORTRAIT") {
    return raw
  }
  if (raw === "adapt") {
    return "AUTO"
  }
  if (raw === "square") {
    return "SQUARE"
  }
  if (raw === "portrait") {
    return "PORTRAIT"
  }
  if (raw === "2" || raw === 2) {
    return "PORTRAIT"
  }
  if (raw === "1" || raw === 1) {
    return "AUTO"
  }
  if (raw === "3" || raw === 3) {
    return "SQUARE"
  }

  return "SQUARE"
}

export const mergeThemeBottomSection = (
  raw: ThemeBottomSectionState | undefined,
): ThemeBottomSectionState => {
  const defaults = createDefaultThemeBottomSection()

  return {
    images: normalizeImageItems(raw?.images ?? defaults.images),
    video: normalizeVideo(raw?.video),
    imageRatio: normalizeImageRatio(raw?.imageRatio ?? defaults.imageRatio),
  }
}

export const newThemeBottomId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  const suffix = Math.random()
    .toString(16)
    .slice(2)

  return `tb-${Date.now()}-${suffix}`
}
